import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { backToOffers, nextStep } from "containers/MultistepForm/actions";
import { tokenSelector } from "../../../../EmbeddableWidget/selectors";
import { logEvent } from "../../../../EmbeddableWidget/actions";
import { addThousandsSeparator } from "../../../../../utils/helpers";
import { ProvidersApi } from "../../../../../api/providers";

import "./styles.scss";

class KafeneApprovedAppScreen extends Component {
  state = {
    loadingInvoice: false,
  };

  submit = () => {
    const { offer, nextStep, token } = this.props;
    this.setState({ loadingInvoice: true });

    ProvidersApi.kafeneCreateInvoice(token, { app_id: offer.app_id })
      .then((invoiceData) => {
        nextStep({
          step: "kafeneOfferDetails",
          data: { ...offer, ...invoiceData },
        });
      })
      .catch(() => {
        nextStep({
          step: "kafenePendingAppScreen",
          data: offer,
        });
      })
      .finally(() => {
        this.setState({ loadingInvoice: false });
      });
  };

  render() {
    const { loading, offer } = this.props;
    const { loadingInvoice } = this.state;
    const approvedAmount = `$${addThousandsSeparator(offer.approval_amount || offer.approved_amount)}`;

    return (
      <div className="kafene-approved-screen">
        <div className="kafene-approved-screen__icon">
          🎉
        </div>

        <h1 className="kafene-approved-screen__title">Application Approved</h1>
        
        <p className="kafene-approved-screen__subtitle">
          Congratulations! You've been approved for a lease up to {approvedAmount}.
        </p>

        <div className="kafene-approved-screen__amount-box">
          <div className="kafene-approved-screen__amount-label">
            Accepted Lease Amount up to
          </div>
          <div className="kafene-approved-screen__amount">
            {approvedAmount}
          </div>
        </div>

        <p className="kafene-approved-screen__info">
          This will not require a hard pull on your credit, and will not impact your credit score.
          Continue with your purchasing process.
        </p>

        <BlueBtn
          customClass="bank-data-form-submit-btn"
          disabled={loading || loadingInvoice}
          loading={loading}
          onClick={this.submit}
        >
          Proceed to create invoice
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  token: tokenSelector()(state),
  offer: activeStepDataSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    backToOffers: () => dispatch(backToOffers()),
    logEvent: (value) => dispatch(logEvent(value)),
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

KafeneApprovedAppScreen = connect(
  mapStateToProps,
  mapDistpatchToProps
)(KafeneApprovedAppScreen);

export default KafeneApprovedAppScreen;
